export default __webpack_public_path__ + "static/img_interviewee_sychoi-0a0e92a5db66ff2b86cb91ec8b3fa34d.png";